import { render, staticRenderFns } from "./StudentScholarship.vue?vue&type=template&id=d7b2e516&"
import script from "./StudentScholarship.vue?vue&type=script&lang=js&"
export * from "./StudentScholarship.vue?vue&type=script&lang=js&"
import style0 from "./StudentScholarship.vue?vue&type=style&index=0&id=d7b2e516&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports